import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import Container from './Container';
import logo from '../assets/logo.jpg';
import hidevLogo from '../assets/hidev_logo.png';

const FooterWrapper = styled.footer`
  background-color: ${props => props.theme.colors.darkBg};
  color: ${props => props.theme.colors.light};
  padding: ${props => props.theme.spacing.xl} 0;
`;

const FooterContainer = styled(Container)`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  
  @media (max-width: ${props => props.theme.breakpoints.md}) {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
`;

const LogoContainer = styled.div`
  flex: 1;
  
  @media (max-width: ${props => props.theme.breakpoints.md}) {
    margin-bottom: ${props => props.theme.spacing.xl};
  }
`;

const Logo = styled.img`
  max-height: ${props => props.theme.spacing.xxxl};
  width: auto;
  
  @media (max-width: ${props => props.theme.breakpoints.md}) {
    max-height: ${props => props.theme.spacing.xxl};
  }
`;

const NavContainer = styled.div`
  flex: 2;
  display: flex;
  justify-content: center;
  
  @media (max-width: ${props => props.theme.breakpoints.md}) {
    margin-bottom: ${props => props.theme.spacing.xl};
    width: 100%;
  }
`;

const NavColumn = styled.div`
  margin: 0 ${props => props.theme.spacing.lg};
  
  @media (max-width: ${props => props.theme.breakpoints.md}) {
    margin: 0 ${props => props.theme.spacing.md};
  }
`;

const NavHeading = styled.h4`
  font-family: ${props => props.theme.fonts.heading};
  font-weight: ${props => props.theme.fontWeights.semiBold};
  font-size: ${props => props.theme.fontSizes.md};
  color: ${props => props.theme.colors.light};
  margin-bottom: ${props => props.theme.spacing.md};
`;

const NavList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

const NavItem = styled.li`
  margin-bottom: ${props => props.theme.spacing.sm};
`;

const NavLink = styled(Link)`
  color: ${props => props.theme.colors.lightGray};
  text-decoration: none;
  font-size: ${props => props.theme.fontSizes.sm};
  transition: ${props => props.theme.transitions.fast};
  
  &:hover {
    color: ${props => props.theme.colors.light};
    text-decoration: underline;
  }
`;

const HiDevContainer = styled.div`
  flex: 1;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  
  @media (max-width: ${props => props.theme.breakpoints.md}) {
    justify-content: center;
  }
`;

const HiDevLogo = styled.img`
  max-height: ${props => props.theme.spacing.xxl};
  width: auto;
`;

const BottomBar = styled.div`
  margin-top: ${props => props.theme.spacing.xl};
  padding-top: ${props => props.theme.spacing.md};
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  text-align: center;
  font-size: ${props => props.theme.fontSizes.sm};
  color: ${props => props.theme.colors.lightGray};
`;

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <FooterWrapper>
      <FooterContainer>
        <LogoContainer>
          <Link to="/">
            <Logo src={logo} alt="Project Assist Logo" />
          </Link>
          <p style={{ fontSize: '0.875rem', marginTop: '1rem' }}>EIN: 88-1941937</p>
        </LogoContainer>

        <NavContainer>
          <NavColumn>
            <NavHeading>Pages</NavHeading>
            <NavList>
              <NavItem>
                <NavLink to="/">Home</NavLink>
              </NavItem>
              <NavItem>
                <NavLink to="/our-projects">Our Projects</NavLink>
              </NavItem>
              <NavItem>
                <NavLink to="/latest">Latest</NavLink>
              </NavItem>
              <NavItem>
                <NavLink to="/#team">Team</NavLink>
              </NavItem>
              <NavItem>
                <NavLink to="/donate">Donate</NavLink>
              </NavItem>
            </NavList>
          </NavColumn>

          <NavColumn>
            <NavHeading>Contact</NavHeading>
            <NavList>
              <NavItem>
                <NavLink to="/#contact">Contact Us</NavLink>
              </NavItem>
              <NavItem>
                <a href="mailto:admin@project-assist.net" style={{ color: '#E9ECEF', textDecoration: 'none', fontSize: '0.875rem' }}>
                  admin@project-assist.net
                </a>
              </NavItem>
            </NavList>
          </NavColumn>
        </NavContainer>

        <HiDevContainer>
          <a href="https://hidevmobile.com" target="_blank" rel="noopener noreferrer">
            <HiDevLogo src={hidevLogo} alt="HiDev Logo" />
          </a>
        </HiDevContainer>
      </FooterContainer>

      <Container>
        <BottomBar>
          <p>© {currentYear} Project Assist. All rights reserved.</p>
          <p style={{ marginTop: '0.5rem' }}>Empowering individuals, families & communities to create a path to self sustainability</p>
        </BottomBar>
      </Container>
    </FooterWrapper>
  );
};

export default Footer; 